import { TableColumnConfigDto } from '@asset-metrix/portal-gateway-client-js';

/**
 * In group-only mode the table is flat: grouping is cleared so ag-grid
 * does not render group rows, and column visibility is adjusted to only
 * show the selected group column plus columns that provide aggregate data.
 */
export function patchColumnsForGroupOnlyMode(
  columns: TableColumnConfigDto[],
  groupOnlyColumnId: string
): TableColumnConfigDto[] {
  return columns.map((c) => ({
    ...c,
    grouping: undefined,
    hidden:
      c.id === groupOnlyColumnId ? false : !c.appearsInFooter || !!c.hidden,
  }));
}
